import _get from 'lodash/get';
import { KEY_VALUE_LAYOUT, KeyConfig } from 'commons-ui';

import { TRANSACTION_TYPES, TRANSACTION_TYPES_LABEL } from '../constant';
import { VIEW_FIELD_KEYS } from './constants';
import useService from './useService';

export const getKeyConfig = (transactionAllDetails: any) => {
	const transactionType = _get(transactionAllDetails, VIEW_FIELD_KEYS.TRANSACTION_TYPE);
	const { getTransactionDetails, getPaymentDetails } = useService(transactionAllDetails);
	const data = getTransactionDetails();

	const keyConfig: KeyConfig = {
		childConfig: [
			{
				name: VIEW_FIELD_KEYS.TRANSACTION_ID,
				label: 'Transaction Id'
			},
			{
				name: VIEW_FIELD_KEYS.RAZORPAY_PAYOUT_ID,
				label: 'Razorpay Payout ID',
				isHidden: transactionType !== TRANSACTION_TYPES_LABEL[TRANSACTION_TYPES.WITHDRAWAL]
			},
			{
				name: VIEW_FIELD_KEYS.TRANSACTION_TYPE,
				label: 'Transaction Type'
			},
			{
				name: VIEW_FIELD_KEYS.MESSAGE,
				label: 'Message'
			},
			{
				name: VIEW_FIELD_KEYS.STATUS,
				label: 'Status'
			},
			// {
			// 	name: VIEW_FIELD_KEYS.TICKETS_RAISED,
			// 	label: 'Tickets raised'
			// },
			{
				name: VIEW_FIELD_KEYS.TRANSACTION_TIMESTAMP,
				label: 'Transaction Timestamp'
			},
			{
				name: VIEW_FIELD_KEYS.TOURNAMENT_ID,
				label: 'Tournament Id',
				isHidden: !data.tournamentId
			},
			{
				name: VIEW_FIELD_KEYS.GAME_NAME,
				label: 'Game Name',
				isHidden: !data.gameName && !data.tournamentId
			},
			{
				name: VIEW_FIELD_KEYS.MATCH_NAME,
				label: 'Match Name',
				isHidden: !data.matchName
			},
			{
				name: VIEW_FIELD_KEYS.CGR_ID,
				label: 'Continuous Gameplay Id',
				isHidden: data.type !== 51 && data.type !== 50
			},
			{
				name: VIEW_FIELD_KEYS.TRANSACTION_AMOUNT,
				label: 'Transaction Amount (₹)'
			},
			{
				name: VIEW_FIELD_KEYS.BONUS,
				label: 'Bonus (₹)'
			},
			{
				name: VIEW_FIELD_KEYS.WINNINGS,
				label: 'Winnings (₹)'
			},
			{
				name: VIEW_FIELD_KEYS.DEPOSIT,
				label: 'Deposit (₹)'
			},
			{
				name: VIEW_FIELD_KEYS.COUPONS_USED,
				label: 'Coupons Used'
			},
			{
				name: VIEW_FIELD_KEYS.COUPON_ID,
				label: 'Coupon Id'
			},
			{
				name: VIEW_FIELD_KEYS.COINS_ADDED_TID,
				label: 'Coins Added Transaction Id',
				isHidden: data.type !== 29001 && data.type !== 31001
			},
			{
				name: VIEW_FIELD_KEYS.CASHBACK,
				label: 'Cashback (₹)'
			},
			{
				name: VIEW_FIELD_KEYS.GST_TRANSACTION_ID,
				label: 'GST Transaction ID'
			},
			{
				name: VIEW_FIELD_KEYS.DEPOSIT_TRANSACTION_ID,
				label: 'Deposit Transaction ID'
			},
			{
				name: VIEW_FIELD_KEYS.GST_AMOUNT,
				label: 'GST Amount'
			},
			{
				name: VIEW_FIELD_KEYS.PG_AMOUNT,
				label: 'PG Amount'
			},
			{
				name: VIEW_FIELD_KEYS.PAYMENT_DETAILS,
				label: 'Payment Details',
				initiallyCollapsed: true,
				fetchData: getPaymentDetails,
				childConfig: [
					{
						name: VIEW_FIELD_KEYS.PAYMENTGATEWAY,
						label: 'Payment Gateway'
					},
					{
						name: VIEW_FIELD_KEYS.PAYMENT_GATEWAY_TRANSACTION_ID,
						label: 'Payment Gateway Transaction Id'
					},
					{
						name: VIEW_FIELD_KEYS.PAYMENT_METHOD,
						label: 'Payment Method'
					},
					{
						name: VIEW_FIELD_KEYS.PAYMENT_STATUS,
						label: 'Status'
					},

					{
						name: VIEW_FIELD_KEYS.ORDER_AMOUNT,
						label: 'Order Amount (₹)'
					},
					{
						name: VIEW_FIELD_KEYS.CLEARANCE_AMOUNT,
						label: 'Clearance Amount (₹)'
					},
					{
						name: VIEW_FIELD_KEYS.UPDATED_AT,
						label: 'Updated At'
					},
					{
						name: VIEW_FIELD_KEYS.PAYMENT_TRANSACTION_TIMESTAMP,
						label: 'Transaction Timestamp'
					}
				]
			}
		],
		fetchData: getTransactionDetails,
		name: VIEW_FIELD_KEYS.TRANSACTION_DETAILS,
		label: 'Transaction Details',
		initiallyCollapsed: false
	};
	const keyValueLayout = KEY_VALUE_LAYOUT.VERTICAL;

	return {
		keyConfig,
		keyValueLayout
	};
};
